module.exports = __webpack_public_path__ + "img/Menu-03.8743ba3a.png";